import React from 'react';

const Sidebar = ({ activeTab, handleTabClick, isSidebarOpen }) => {
    return (
        <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
            <div className="tab-links">
                <button
                    onClick={() => handleTabClick('orders')}
                    className={activeTab === 'orders' ? 'active' : ''}
                >
                    Orders
                </button>
                     
               
                <button
                    className={activeTab === 'customers' ? 'active' : ''}
                    onClick={() => handleTabClick('customers')}
                >
                    Customers
                </button>
                <button
                    className={activeTab === 'analytics' ? 'active' : ''}
                    onClick={() => handleTabClick('analytics')}
                >
                    Analytics
                </button>
               
                <button
                    className={activeTab === 'table-bookings' ? 'active' : ''}
                    onClick={() => handleTabClick('table-bookings')}
                >
                    Table Bookings
                </button>
                <button
                    className={activeTab === 'items' ? 'active' : ''}
                    onClick={() => handleTabClick('items')}
                >
                    Instock Items
                </button>
                <button
                    className={activeTab === 'outofstock' ? 'active' : ''}
                    onClick={() => handleTabClick('outofstock')}
                >
                    Sold Out
                </button>
                <button
                    className={activeTab === 'categories' ? 'active' : ''}
                    onClick={() => handleTabClick('categories')}
                >
                    Categories
                </button>
                
            </div>
        </div>
    );
};

export default Sidebar;
